module.exports = __webpack_public_path__ + "img/nodata.d9186ee7.svg";